<template>
  <card
    class="custom-shadow-card-header custom-table-responsive"
    :title="`${$t('production.bunched_bagged_per_hectare')} ${
      getSizeFarmList === 1
        ? ` - ${$t('common_words.farm')}: ${farmList[0].name}`
        : ``
    }`"
  >
    <el-container>
      <aside-list
        addClass=".el-menu-byTotalHa"
        @clickItem="handleChangeMenuSelected"
        :label="$t('common_words.farms')"
        optionIndex="byTotalHa"
        :list="farmList"
        v-if="getSizeFarmList > 1"
      />
      <el-container v-if="dataFarm && getSizeFarmList > 0">
        <el-main
          :style="
            getSizeFarmList == 1
              ? 'paddingLeft: 0 !important; overflow: hidden;'
              : ''
          "
        >
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead-pockets
                    :columns="dataFarm.columns"
                    :labelFirstCell="$t('production.baggd')"
                  />
                  <tfoot>
                    <tfoot-totals
                      :totalCoveredAreas="dataFarm.totalCoveredAreas"
                      :totalColumns="dataFarm.totalColumns"
                      :columns="dataFarm.columns"
                      option="byTotalHa"
                    />
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12" v-if="isExcel()">
              <div class="text-center">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel('byTotalHa', 3)"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </card>
</template>
<script>
import AsideList from 'src/components/Layouts/AsideList.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import TfootTotals from './TfootTotals.vue';
import TheadPockets from './TheadPockets.vue';

export default {
  name: 'report-by-total-has',
  components: {
    [AsideList.name]: AsideList,
    [TfootTotals.name]: TfootTotals,
    [TheadPockets.name]: TheadPockets,
  },
  props: {
    farmList: {
      type: Array,
      default: [],
    },
    dataFarm: {
      type: Array | Object,
    },
  },
  computed: {
    getSizeFarmList() {
      if (this.farmList) return Object.keys(this.farmList).length;
      else return 0;
    },
  },
  mixins: [MixinPermissions],
  methods: {
    handleChangeMenuSelected(data) {
      this.$emit('handleChangeMenuSelected', data);
    },
    exportToExcel(optionFront, optionBackend) {
      this.$emit('exportToExcel', {
        optionFront: optionFront,
        optionBackend: optionBackend,
      });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.getSizeFarmList == 1) {
        this.handleChangeMenuSelected({
          id: this.farmList[0].id,
          option: 'byTotalHa',
        });
      } else {
        document.getElementsByClassName('.el-menu-' + 'byTotalHa')[0].click();
      }
    }, 100);
  },
};
</script>
<style scoped>
::v-deep .card-title {
  font-weight: 400;
}
</style>
